import { render, staticRenderFns } from "./ExchangeRecordDialog.vue?vue&type=template&id=31b6bcb8&scoped=true"
import script from "./ExchangeRecordDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecordDialog.vue?vue&type=style&index=0&id=31b6bcb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6bcb8",
  null
  
)

export default component.exports